var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',[_c('v-text-field',{attrs:{"append-icon":"mdi-magnify","label":"Search","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_c('v-data-table',{attrs:{"height":_vm.height,"search":_vm.search,"headers":_vm.headers,"items":_vm.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }